var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-dialog',{attrs:{"title":"查看详情","visible":_vm.dialogVisible},on:{"update:visible":function($event){_vm.dialogVisible=$event},"close":function($event){return _vm.$emit('update:visible',false)}}},[_c('div',{staticClass:"dialog_conwrap"})])
}
var staticRenderFns = []

export { render, staticRenderFns }